import { type App, createApp } from 'vue'
import { PARTIAL_VIEW, fullAppSelector, homeAppSelector } from './constants'
import { createI18n } from 'vue-i18n'
import { createMainRouter, createPartialRouter } from '@/utils/router/index'
import RootComponent from '@/App.vue'

/**
 * Create an i18n instance.
 */
const i18n = createI18n({
    availableLocales: ['en'],
    locale: 'en-AU',
    fallbackLocale: 'en-AU',
    legacy: false
})

/**
 * Extend the app.Setting partial to `true` allows
 * the rendering of specific views of the app instead
 * of the full app.
 */
export function extendApp(app: App, el: HTMLElement, partial = false) {
    const router = partial ? createPartialRouter(el) : createMainRouter()
    app.config.globalProperties.router = router
    app.provide(PARTIAL_VIEW, partial)
    app.use(i18n)
    return app
}

/**
 * Mount the app.
 */
export function mountApp(el: HTMLElement | null, partial = false) {
    if (!el) return

    const app = createApp(RootComponent)

    return extendApp(app, el, partial).mount(el)
}

/**
 * Mount the main app using the id selector or
 * all partial views using the class selector.
 */
const main = document.querySelector<HTMLElement>(fullAppSelector)

if (main) {
    mountApp(main)
} else {
    document
        .querySelectorAll<HTMLElement>(homeAppSelector)
        .forEach(el => mountApp(el, true))
}
